if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      if(this.form.querySelector('[name=id]')) {
        this.form.querySelector('[name=id]').disabled = false;
      }
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      if (this.dataset.freeGift) {
        const cookie = `freegifts-removed:${getCookie('cart')}`
        let freegifts_removed = getCookie(cookie);
        if (freegifts_removed) {
          freegifts_removed = JSON.parse(freegifts_removed);
          const index = freegifts_removed.indexOf(this.dataset.freeGift);
          if (index !== -1) {
            freegifts_removed.splice(index, 1);
            setCookie(cookie, JSON.stringify(freegifts_removed), 1440);
          }
        }
      }

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            this.error = true;
            this.submitButton.classList.add('error-feedback');
            setTimeout(() => {
              this.submitButton.classList.remove('error-feedback');
            }, 600);

            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddViewer = this.closest('quick-add-viewer');
          if (quickAddViewer) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddViewer.hide(true);
          } else {
            this.cart.renderContents(response);
          }

          const drawerSetOfProducts = this.form.dataset.section;
          if (drawerSetOfProducts) {
            const productDrawer = document.querySelector(`#drawer-${drawerSetOfProducts}`);
            productDrawer.classList.toggle('active');
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          const justOnce = this.submitButton.classList.contains('add-just-once');
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          if (justOnce) return;
          this.submitButton.removeAttribute('aria-disabled');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  }

  customElements.define('product-form', ProductForm);
}
